import { render, staticRenderFns } from "./PSContinueQuote.vue?vue&type=template&id=4b74c596&scoped=true&"
import script from "./PSContinueQuote.vue?vue&type=script&lang=js&"
export * from "./PSContinueQuote.vue?vue&type=script&lang=js&"
import style0 from "./PSContinueQuote.vue?vue&type=style&index=0&id=4b74c596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74c596",
  null
  
)

export default component.exports